/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect, useState } from 'react'
import { BulletList } from 'react-content-loader'

import '../../ShopList/list.scss'

import { useNavigate } from 'react-router-dom'

export default function index(data) {
  const [category, setCategory] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    setCategory(data.data)
  }, [data])

  return (
    <>
      <table className='table'>
        <thead>
          <tr>
            <th>نام پیک</th>
            <th>شماره موبایل</th>
            <th>کد ملی</th>
            <th>مقطع تحصیلی</th>
            <th>وضعیت</th>
            <th>عملیات</th>
          </tr>
        </thead>
        <tbody>
          {category ? category.map(item => (
              <tr key={item._id}>
                <td>{item.name}</td>
                <td>0{item.phoneNumber}</td>
                <td>{item.meliCode}</td>
                <td>{item.education}</td>
                <td>{item.status === true ? (
                  <span className='success'>فعال</span>
                ) : (
                  <sapn className='failed'>غیرفعال</sapn>
                )}</td>
                <td>
                  <button onClick={() => navigate(`/peyk/peyks/edit/${item._id}`)}>مشاهده</button>
                </td>
              </tr>
            )) : <tr><td colSpan="5"><BulletList rtl style={{ width: '30%', rowspan: '5' }}/></td></tr>}
        </tbody>
      </table>
    </>
  );
}
